// extracted by mini-css-extract-plugin
module.exports = {"pulsating":"nav_demo-module__pulsating--2FVVe","circle":"nav_demo-module__circle--gYy_l","smallCircle":"nav_demo-module__smallCircle--vyDBy","text":"nav_demo-module__text--2A04h"};